
import { Link, useSearchParams } from 'react-router-dom';

import styles from './LeftLinks.module.css'
import { NavBarSiteSearchParamsValues } from './Index';
import { ExternalNavLinks } from './ExternalNavLinks';

export const LeftLinks = ({ className }) => {
    const leftLinks = ExternalNavLinks();
    const [searchParams, setSearchParams] = useSearchParams();

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }
    return leftLinks.map(({ label, path, showWidth, id, _onclick }) => {

        const newParams = new URLSearchParams(searchParams);
        newParams.set(NavBarSiteSearchParamsValues.nav_value, id); // atualiza ou adiciona o parâmetro
        const nav_value = searchParams.get(NavBarSiteSearchParamsValues.nav_value);
        let allowHighlightClass = false;
        if (showWidth) {
            if (window.innerWidth > showWidth) { return null }
            allowHighlightClass = true;
        }
        return (
            <Link
                onClick={() => {
                    scrollToTop()
                    _onclick?.();
                }}
                className={`
                    ${styles.Link} 
                    ${(nav_value == id || (!path && !nav_value && !window.location.hash.split('?')[0].replaceAll('#/', ''))) ? styles.PageSelected : ''} 
                    ${allowHighlightClass ? styles.Highlight : ''}
                    ${className}
                `}
                key={id}
                to={`${path}/?${newParams.toString()}`}
            >{label}</Link>
        )
    });
}

export const LeftLinksGetSelected = ({ refBarTitle }) => {
    const leftLinks = ExternalNavLinks()
    const [searchParams, setSearchParams] = useSearchParams();
    return leftLinks.map(({ label, path, id }) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set(NavBarSiteSearchParamsValues.nav_value, id); // atualiza ou adiciona o parâmetro
        const nav_value = searchParams.get(NavBarSiteSearchParamsValues.nav_value);
        const title = refBarTitle?.current;
        if (title && nav_value === id) { title.innerText = label }
        return null
    });
}